import toUrlParams from '../url/toUrlParams';
import METHODS from './_http-methods';
import HEADERS from './_http-headers';

/**
 * Prepares the configuration object before sending the request.
 *
 * @param  {Object} config: the configuration object to send the request
 * @return {Object}
 */
export default function prepareRequest(config) {
  const isGET = METHODS.fromUrl.test(config.method);
  const isJSON = (/json/).test(config.headers['Content-Type']);
  config.method = config.method.toUpperCase();
  if (config.body != null) config.data = config.body;
  if (config.data != null && config.processData) {
    if (isGET) config.url += toUrlParams(config.data);
    else if (isJSON) config.data = JSON.stringify(config.data);
  }
  for (const key in HEADERS) {
    // allow override default headers
    if (key in config.headers) continue;
    config.headers[key] = HEADERS[key];
  }
  return config;
}
